/**
 * Что из SEO-конфига уезжает в Angular — чистый модуль (без Angular), поэтому под
 * node-спекой. Единственный писатель `SEO_CONFIG_STATE_KEY` (`initSeoConfig`) прогоняет
 * ответ бэка через `forTransfer`, так что правило одно на обе платформы.
 */

import type {SeoConfig} from '../../../server/seo-config.contract';

/**
 * Оставляет только те поля, которые читает Angular, — **allowlist, а не вырезание
 * лишнего**: на SSR этот объект уезжает в HTML каждой страницы, и денилист означал бы,
 * что следующее серверное поле контракта попадёт туда по умолчанию. Так уже было с
 * `robots`: кастомный robots.txt из админки (дефолтный пресет — ~1.5 КБ) инлайнился бы в
 * каждую отрендеренную страницу.
 *
 * Node-only поля обнуляются, а не удаляются: `SeoConfig` — общий контракт с серверной
 * стороной, и опциональность полей ради транспорта размывала бы его.
 *
 * Что кому нужно: `robots` отдаёт `robots.handler`, `sitemap` — `sitemap.handler`,
 * `canonicalHost` применяет redirect-middleware, `redirects` — он же; всё это живёт в
 * `server.ts` и читает конфиг из `SeoConfigCache`, а не из этого объекта.
 */
export function forTransfer(cfg: SeoConfig): SeoConfig {
  return {
    // Читает Angular: SeoMetaService, CanonicalUrlBuilder, AnalyticsInjectorService,
    // дашборд (мета главной) и экраны через h1For.
    searchIndexable: cfg.searchIndexable,
    maxIndexablePage: cfg.maxIndexablePage,
    metaDefaults: cfg.metaDefaults,
    pageTypeMeta: cfg.pageTypeMeta,
    homePage: cfg.homePage,
    pagination: cfg.pagination,
    analytics: cfg.analytics,
    // Номер версии — одно число, полезное при отладке («какой конфиг применился»).
    version: cfg.version,
    // Node-only.
    canonicalHost: null,
    robots: '',
    redirects: [],
  };
}
